import React, {useEffect} from "react"
import {withPrefix} from "gatsby"
import styled from "styled-components"
import ReactHtmlParser from "react-html-parser";

import Title from "@airasia/phoenix-components/components/Title"
import Image from "@airasia/phoenix-components/components/Image"
import Text from "@airasia/phoenix-components/components/Text"
import Link from "@airasia/phoenix-components/components/Link"
import Button from "@airasia/phoenix-components/components/Button"
import FAQ from "@airasia/phoenix-widgets/widgets/FAQ"
import Carousel from "@airasia/phoenix-widgets/widgets/CarouselSlider"
import ExpandableTextContainer from "@airasia/phoenix-widgets/widgets/ExpandableTextContainer"

import UNIVERSAL_HEADER_DATA from "../data/header"
import HERO_BANNER_DATA from "../data/HeroBanner"
import FAQ_DATA from "../data/en/faq"
import EXPAND_DATA from "../data/en/expand"
import FOOD_CAROUSEL from "../data/en/carousel"
import WHYBOOK_LIST from "../data/en/WhyBook"
import Layout from "../components/layout"
import "../css/main.css"
import {fireGtmEvent, getGtmUserType} from "../utils/functions"
import { symbol } from "prop-types"

const ContentWrapper = styled.div`
  max-width: 625px;
  margin:3em auto;
  width: 90%;
  
  #ctaButton{width:80%;}


  @media only screen and (min-width: 720px) {
    width: 90%;
    max-width: 976px;

    #ctaButton{width:30%;}
  }

  @media only screen and (min-width: 1025px) {
    width: 90%;
    padding-bottom:1em;
    margin:2em auto;
    padding-top:1em;
    max-width: 1224px;

    #ctaButton{width:30%;}
  }
`

const TitleWrapper = styled.div`

  #title {
    color: #ff0000;
    font-weight: 700;
    font-size: 2rem;
    margin-bottom:0.5em;  
  }
  
  @media only screen and (max-width: 720px) {
    width: 90%;
    margin: 2em 0;

    #title {
      font-size: 1.8rem;
    }
  }
`


const TitleWrapperFlex = styled.div`
  display: flex;

  #title {
    color: #ff0000;
    font-weight: 700;
    font-size: 2rem;
    margin-bottom: 20px;
    padding: 0 5px;
  }

  #foodMerchantImg{}

  @media only screen and (max-width: 720px) {

    #title {
      font-size: 1.8rem;
      padding: 0 5px;
    }
    #foodMerchantImg{display:none;}
  }
`


const ExpandText = styled.div`
  display:block;
  margin-left:2em;

  @media only screen and (max-width: 720px) {
    margin-left:0;
  }
`

const MerchantButton = styled.div`
  width:30%;
  margin:0 auto;

  @media only screen and (max-width: 720px) {
    width:80%;
    margin:0;
  }
`

/*Download section-------*/
const Download = styled.div`
  background-color: #ff0000;
  color: #fff;
  padding: 20px 50px;
`
const DownloadContent = styled.div`
  max-width: 850px;
  display: flex;
  margin: 0 auto;

  @media only screen and (max-width: 600px) {
    display: block;
  }
`
const AppDownload = styled.div`
  display: block;
  margin: 20px auto;
  width: 60%;

  #app-download-text {
    font-style: italic;
    font-size: 1.5rem;
    font-weight: 700;
    margin-bottom: 20px;
  }
  @media only screen and (max-width: 600px) {
    width: 100%;
  }
`
const DownloadAppWrapper = styled.div`
  display: flex;
  flex-wrap: wrap;
`
const DownloadApp = styled.div`
  margin: 3px;

  #download-image {
    background-color: transparent;
  }
`
const SuperAppIconWrapper = styled.div`
  width: 15%;
  margin: auto;

  #superapp-image {
    background-color: transparent;
  }
  @media only screen and (max-width: 600px) {
    display: none;
  }
`
const DownloadButtonWrapper = styled.div`
  margin: auto;

  #buttonDownload {
    border-radius: 40px;
    font-style: italic;
  }
  @media only screen and (max-width: 600px) {
    width: 100%;
  }
`
const IndexPage = () => {
    const updateLocale = (obj) => {
        window.location.href = withPrefix(obj.detail)
    }

    useEffect(() => {
        if (typeof window !== 'undefined') {
            window.addEventListener("uhfLocaleChange", updateLocale)
        }
    }, [])

    return (
        <Layout canonical="https://www.airasia.com/aa/become-food-merchant"
                title="Earn More as an Online Food Delivery, join airasia Food Merchant"
                description="Grow your business by partner with airasia food Merchant today! Get your food and grocer delivery to more hungry consumers. Find out more how our online food delivery works here!"
                keywords="airasia food merchant, airasia food delivery merchant, airasia food merchant sign up, how to become airasia food merchant, airasia food delivery partner, food delivery companies, food business, food merchant, food business from home, food delivery partner"
                bannerData={HERO_BANNER_DATA}
                headerData={UNIVERSAL_HEADER_DATA}
        >
            <ContentWrapper>
              <TitleWrapper>
                    <Title
                        accessible
                        inverted={false}
                        textAlign="left"
                        type="h1"
                        marginBottom="XXSmall"
                        customProperties={{id: 'title'}}
                    >
                        Sell More, Earn More as an Airasia food Online Restaurant.
                    </Title>
                    </TitleWrapper>
                    <Text
                        accessible
                        display="inlineFlex"
                        hasToggle={false}
                        opacity={1}
                        tag="p"
                        marginTop="none"
                        textAlign="left"
                        theme="AIRASIA_CLASSIC"
                        translation={{}}
                        type="default"
                    >
                        Make your catering or restaurant business more profitable by becoming a food merchant Malaysia. The pandemic recently has created a new way of dining and the public has embraced this concept of online order when it comes to buying food and drinks. Gone are the days of driving out to dine. 
                        <br/><br/>
                        Nowadays, all the customer needs to do is to pick up his smartphone and order his favourite meal from an online restaurant. Within minutes, the food will arrive at his address - fresh and fast! Become an online food delivery merchant and see your business take-off. It is that simple!
                    </Text>
            </ContentWrapper>
            
            <ContentWrapper>
              <TitleWrapperFlex>
                <Image
                  accessible
                  centerFocus={true}
                  enableProgressiveImageLoading={false}
                  lazyLoadImage={false}
                  placeHolderBackground="tertiary"
                  radius="10px"
                  src="https://www.airasia.com/aa/images/web-apps/content-pages/library/AA-Become-Food-Merchant.jpg"
                  theme="AIRASIA_CLASSIC"
                  width="100%"
                  customProperties={{id: 'foodMerchantImg'}}
                />
            
              <ExpandText>
            <ExpandableTextContainer
              accessible
              dataProperties={{
                titleMarginBottom: 'tiny',
                titleType: 'h2',
                
              }}
              data={EXPAND_DATA}
              theme="AIRASIA_CLASSIC"
              
            />
            </ExpandText>
            </TitleWrapperFlex>
            </ContentWrapper>


            <ContentWrapper>
              <TitleWrapper>
                    <Title
                        accessible
                        inverted={false}
                        textAlign="left"
                        type="h2"
                        customProperties={{id: 'title'}}
                    >
                        Join the Best, Ignore the Rest
                    </Title>
                    </TitleWrapper>
                    <Text
                        accessible
                        display="inlineFlex"
                        hasToggle={false}
                        opacity={1}
                        tag="p"
                        textAlign="left"
                        theme="AIRASIA_CLASSIC"
                        translation={{}}
                        type="default"
                    >
                        Becoming a restaurant partner in the online ordering industry does come with some uncertainties. Many such platforms do not reveal the challenges when business partners sign up food delivery merchants. These often result in poor sales and the eventual drop out of the restaurant partner on many online ordering platforms.
                        <br/><br/>
                        One of the main issues faced by new and existing food merchants is the difficulty to reach out to new customers and to retain existing ones. The online platforms do not offer enough incentives like better discounts or faster food delivery to maintain customer loyalty. 
                        <br/><br/>
                        Perhaps the biggest flaw with such business partnering is the lack of a complete and comprehensive online ordering system. Many restaurant businesses register food delivery services with such platforms but find it difficult to negotiate the contract, the ordering process and fulfillment of customers’ bookings. These platforms simply do not have a business model that is both friendly to the customers and the food delivery merchants.  
                        <br/><br/>
                        Smaller businesses too often cannot compete with the big industry giants that take a large chunk of the revenue, leaving the food merchants with smaller amounts of profit. But online food sales is the way to go to help you grow your business in this highly competitive industry. You just need to find the right partner to work together. 
                    </Text>
            </ContentWrapper>

            <ContentWrapper>  
              <TitleWrapper>
                    <Title
                        accessible
                        inverted={false}
                        textAlign="left"
                        type="h2"
                        customProperties={{id: 'title'}}
                    >
                        Why you should Sign Up as an airasia food Merchant Malaysia?
                    </Title>
                    </TitleWrapper>
                    <Text
                        accessible
                        display="block"
                        hasToggle={false}
                        opacity={1}
                        tag="p"
                        theme="AIRASIA_CLASSIC"
                        translation={{}}
                        type="default"
                    >
                        Joining airasia food as a food delivery merchant has many benefits. 
                        <ul>
                          <li>airasia food charges the lowest commission rate for its online order transactions. </li>
                          <li>no set up fees and you will be on board the merchant food business in just 5 working days. </li>
                          <li>The airasia super App has a very large potential customer base eager to purchase the food you are offering.</li>
                          <li>You can also communicate directly with your customers on the super app to understand their purchasing patterns, likes and dislikes.</li>
                          <li>build a solid customer database, creating personalised interactions for all future purchases.</li>
                          <li>Customers who buy from you on airasia food will also earn airasia Points with can be used to redeem flight and other airasia products. It is a great way to retain customers who will return for repeat orders at your online restaurant. </li>
                        </ul>

                    </Text>
                    
                    {/* <MerchantWrapper>
                       {WHYBOOK_LIST &&
                       WHYBOOK_LIST.map(whybook => {
                       return (
                       <Merchant>
                       <Image
                          accessible
                          width="70%"
                          customProperties={{
                          id: "merchant-image"
                          }}
                          src={whybook.imageUrl} alt={whybook.altText}
                       />
                       <TitleWrapper>
                       <Title
                           accessible
                           inverted={false}
                           textAlign="center"
                           type="h3"
                           color="primary"
                           customProperties={{id: ''}}
                      >
                      <br />{whybook.title}
                      </Title>
                      <Title
                           accessible
                           inverted={false}
                           textAlign="center"
                           theme="AIRASIA_CLASSIC"
                           type="h3"
                           customProperties={{id: 'subtitle'}}
                      >
                      {whybook.subtitle} {whybook.subtitle2}<br /><span style={{fontSize: "0.9rem"}}>{whybook.disclaimer}<br />{whybook.subtitle3}</span>
                      </Title>
                      </TitleWrapper>
                      </Merchant>
                      )
                      })
                      }
                    </MerchantWrapper> */}
            </ContentWrapper>

            <ContentWrapper>
              <TitleWrapper>
                    <Title
                        accessible
                        inverted={false}
                        textAlign="left"
                        type="h2"
                        customProperties={{id: 'title'}}
                    >
                        Airasia Food Merchant Registration Process
                    </Title>
                    </TitleWrapper>
                    <Text
                        accessible
                        display="inlineFlex"
                        hasToggle={false}
                        opacity={1}
                        tag="p"
                        textAlign="left"
                        theme="AIRASIA_CLASSIC"
                        translation={{}}
                        type="default"
                    >
                        The process to get on board airasia food as an airasia merchant partner is simple and hassle-free. Here’s a quick rundown on the airasia food merchant sign up process. Once you have decided to open a restaurant with airasia, simply visit the website and sign up. Upon confirmation of joining, the airasia food team will reach out to assist you with account registration and store creation process. You can provide details such as store information, menu information and other supporting documents. 
                        <br/><br/>
                        From this point, if documentation is in order, your account will be approved as early as 2 working days. The airasia food will next assist in setting up your store and menu within 3 working days. And that’s it. You are now set to start selling your online food business with airasia food.
                    </Text>
                    <br/>
                    <Button
                    accessible
                    buttonType="button"
                    boxShadow
                    customProperties={{
                      id: 'ctaButton',
                    }}
                    margin={[
                      'small',
                      'none',
                      'none',
                      'none'
                    ]}
                    fontWeight="bold"
                    size="normal"
                    target="tab"
                    width="80%"
                    type="normal"
                    color="primary"
                    target="tab"
                    width="30%"
                    backgroundColor="default"
                    handleClick={() => {
                      fireGtmEvent({
                        "event": 'trackEventNoEcommerce',
                            "eventDetails.category": "Become Foor Merchant | Register Now",
                            "eventDetails.action": "click",
                            "eventDetails.label": `Register Now | ${getGtmUserType()}`
                      })
                      window.open("https://share.hsforms.com/1xGPLMyMMQremeue9-Rv7Sw5hd9h")
                    }}
                  >
                    Register now
                  </Button>
                    
                    {/* <MerchantWrapper>
                       {WHYBOOK_LIST &&
                       WHYBOOK_LIST.map(whybook => {
                       return (
                       <Merchant>
                       <Image
                          accessible
                          width="70%"
                          customProperties={{
                          id: "merchant-image"
                          }}
                          src={whybook.imageUrl} alt={whybook.altText}
                       />
                       <TitleWrapper>
                       <Title
                           accessible
                           inverted={false}
                           textAlign="center"
                           type="h3"
                           color="primary"
                           customProperties={{id: ''}}
                      >
                      <br />{whybook.title}
                      </Title>
                      <Title
                           accessible
                           inverted={false}
                           textAlign="center"
                           theme="AIRASIA_CLASSIC"
                           type="h3"
                           customProperties={{id: 'subtitle'}}
                      >
                      {whybook.subtitle} {whybook.subtitle2}<br /><span style={{fontSize: "0.9rem"}}>{whybook.disclaimer}<br />{whybook.subtitle3}</span>
                      </Title>
                      </TitleWrapper>
                      </Merchant>
                      )
                      })
                      }
                    </MerchantWrapper> */}
            </ContentWrapper>

            <ContentWrapper>
              <TitleWrapper>
                    <Title
                        accessible
                        inverted={false}
                        textAlign="left"
                        type="h2"
                        customProperties={{id: 'title'}}
                    >
                        Airasia Food Merchant's Partner
                    </Title>
                    </TitleWrapper>
                    <Text
                        accessible
                        tag="p"
                    >
                        From big F&B business to small restaurant partners, airasia food has over 5,000 F&B business partners in Malaysia alone. airasia food’s expansion in Singapore, Thailand and Indonesia. Some of our happy airasia food partners in Malaysia include
                    </Text>
                    <br/><br/>
                    <Carousel
                        accessible
                        columnSpan="3"
                        allowLocaleFormat={true}
                        data={FOOD_CAROUSEL.data}
                        heading={FOOD_CAROUSEL.data}
                        isHideFooter={false}
                        showNextButton
                        showPrevButton={false}
                        templateType="productCard"
                        theme="AIRASIA_CLASSIC"
                        fireGtm={fireGtmEvent}
                        gtmConsumerName="productCard"
                      />
                      <br/>
                      <Button
                    accessible
                    buttonType="button"
                    boxShadow
                    customProperties={{
                      id: 'ctaButton',
                    }}
                    fontWeight="bold"
                    size="normal"
                    target="tab"
                    width="80%"
                    type="normal"
                    color="primary"
                    target="tab"
                        width="30%"
                    backgroundColor="default"
                    handleClick={() => {
                      fireGtmEvent({
                        "event": 'trackEventNoEcommerce',
                            "eventDetails.category": "Become Foor Merchant | View more",
                            "eventDetails.action": "click",
                            "eventDetails.label": `View more merchant here | ${getGtmUserType()}`
                      })
                      window.open("https://www.airasia.com/aa/restaurant-lists/")
                    }}
                  >
                    View more merchant here
                  </Button>
                     
            </ContentWrapper>

            <ContentWrapper>
            <Title
                        accessible
                        inverted={false}
                        textAlign="center"
                        type="h2"
                        customProperties={{id: 'title'}}
                    >
                        FAQs
                    </Title>
                    <br/>
                <FAQ
                    data={FAQ_DATA}
                    displayIndex={false}
                    size={{}}
                    theme="AIRASIA_CLASSIC"
                    titleAlign="center"
                    titleMarginBottom="normal"
                    titleType="h3"
                />
            </ContentWrapper>

          <Download>
            <DownloadContent>
              <AppDownload>
                <Text
                  accessible
                  color="default"
                  display="inlineFlex"
                  hasToggle={false}
                  opacity={1}
                  tag="p"
                  theme="AIRASIA_CLASSIC"
                  translation={{}}
                  type="default"
                  customProperties={{
                    id: "app-download-text"
                  }}
                >
                  Send now on airasia Super App
                </Text>
                <DownloadAppWrapper>
                  <DownloadApp>
                    <Link href="https://airasia.onelink.me/F4uy/4823befd">
                      <Image
                        accessible
                        height="45px"
                        customProperties={{
                          id: "download-image"
                        }}
                        src="https://www.airasia.com/aa/images/logo/app-store-badge.png" alt="AirAsia Mobile App - IOS"
                      />
                    </Link>
                  </DownloadApp>
                  <DownloadApp>
                    <Link href="https://airasia.onelink.me/F4uy/c81c277e">
                      <Image
                        accessible
                        height="45px"
                        customProperties={{
                          id: "download-image"
                        }}
                        src="https://www.airasia.com/aa/images/logo/google-play-badge.png"
                        alt="AirAsia Mobile App - Google Play"
                      />
                    </Link>
                  </DownloadApp>
                  <DownloadApp>
                    <Link href="https://appgallery.huawei.com/#/app/C100141357?sharePrepath=ag&channelId=appdownload%20page&id=ed8340378fd24f95a75ba333733a6415&s=65873558A5A2C43D4A9B20499A835032C58C68BDBE39B81310ABF4F176EB4C68&detailType=0&v=">
                      <Image
                        accessible
                        height="45px"
                        customProperties={{
                          id: "download-image"
                        }}
                        src="https://www.airasia.com/aa/images/logo/huawei-app-gallery-badge.png"
                        alt="AirAsia Mobile App - Huawei"
                      />
                    </Link>
                  </DownloadApp>
                </DownloadAppWrapper>
              </AppDownload>
              <SuperAppIconWrapper>
                <Image
                  accessible
                  width="90px"
                  customProperties={{
                    id: "superapp-image"
                  }}
                  src="https://www.airasia.com/aa/ride/images/super-app.png"
                  alt="airasia, The Asean Super App" />
              </SuperAppIconWrapper>
              <DownloadButtonWrapper>
                <Button
                  accessible
                  buttonType="link"
                  customProperties={{
                    id: "buttonDownload",
                    paddingBottom: "1rem",
                    paddingLeft: "1.5rem",
                    paddingRight: "1.5rem",
                    paddingTop: "1rem"
                  }}
                  fontWeight="normal"
                  href="https://airasia.onelink.me/F4uy/8102dac5"
                  size="normal"
                  target="tab"
                  type="normal"
                  color="default"
                  backgroundColor="#fff"
                  hoverBackgroundColor="default"
                  hoverColor="primary"
                >
                  Download Now
                </Button>
              </DownloadButtonWrapper>
            </DownloadContent>
          </Download>
        </Layout>
    )
}
export default IndexPage
